import { equals } from 'ramda'
import { ref } from 'vue'
import { usePolls } from '@/composables/polls'
import {
  POLLS_GROUP_NAME,
  REGISTRATION_POLLS,
} from './consts.js'

const onboardingPolls = ref(null)
const isBusinessWithoutStaffers = ref(false)

const REGISTRATION_POLLS_ORDER = [
  REGISTRATION_POLLS.OTHER_APPS,
  REGISTRATION_POLLS.BOOKING_ADVANCE,
  REGISTRATION_POLLS.BUSINESS_FOCUS,
  REGISTRATION_POLLS.NUMBER_OF_STAFFERS,
]

export function useOnboardingPolls () {
  const { loadPollsList, savePoll } = usePolls()

  const loadPolls = async () => {
    const allPolls = await loadPollsList(POLLS_GROUP_NAME)
    onboardingPolls.value = allPolls?.filter(poll => REGISTRATION_POLLS_ORDER.includes(poll.name))
  }

  const submitPoll = async ({ pollName, choices }) => {
    try {
      const poll = getPoll(pollName)
      if (!poll || equals(poll.savedChoices, choices)) return

      await savePoll({ pollName, choices })
      poll.savedChoices = choices
      let matchedChoices = []
      choices.forEach(choice => {

        let matchingChoice = poll.choices?.find(item => item.id == choice)
        if (matchingChoice) {
          matchedChoices.push(matchingChoice.internal_name)
        }
      })
      poll.savedInternalNamesChoices = matchedChoices

      if (pollName === REGISTRATION_POLLS.NUMBER_OF_STAFFERS) {
        const CHOICE_JUST_ME_ID = poll.choices?.find(choice => choice.internal_name === 'just_me_2')?.id
        isBusinessWithoutStaffers.value = choices.includes(CHOICE_JUST_ME_ID)
      }
      return Promise.resolve()
    } catch ({ response }) {
      return Promise.reject(response.data)
    }
  }

  const getPoll = (pollName) => {
    return onboardingPolls.value?.find(poll => poll.name === pollName)
  }

  return {
    getPoll,
    loadPolls,
    onboardingPolls,
    submitPoll,
    REGISTRATION_POLLS,
    isBusinessWithoutStaffers,
  }
}
